// /src/components/core/HeadersAndFooters/FooterButtonsDetail.jsx
// Footer buttons overlay for detail/content viewing pages
// Used by: ArticleDetail, ChatDetail, EventDetail, AdminGroup
// Note: Help button is in FooterContainer (universal)

import React from 'react';
import StandardButton from '../StandardButton';

function FooterButtonsDetail({
  onCancel = null,
  onSave = null,
  loading = false,
  saveLabel = 'Save',
  cancelLabel = 'Cancel',
  // confirmCancel: set true if cancel should show a confirmation modal (default false —
  // callers that handle unsaved-changes checks themselves can leave this off)
  confirmCancel = false,
  cancelConfirmMessage = 'Your changes will be lost.'
}) {
  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 40px',
      paddingRight: '130px' // Account for Help button on right (50px + 40px + 40px spacing)
    }}>
      {/* Left Section - Reserved for future */}
      <div style={{ display: 'flex', gap: '16px' }}>
        {/* Future: Back button or other navigation */}
      </div>

      {/* Center Section - Action Buttons */}
      {/* ORIGINAL: inline Cancel (#50BDB4 teal) + Save (#5DBEA3 teal) buttons — replaced with StandardButton */}
      {/*
        <button onClick={onCancel} style={{ backgroundColor: '#50BDB4', ... }}>{cancelLabel}</button>
        <button onClick={onSave}   style={{ backgroundColor: '#5DBEA3', ... }}>{saveLabel}</button>
      */}
      <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
        {onCancel && (
          <StandardButton
            variant="destructive"
            iconName="X"
            label={cancelLabel}
            onClick={onCancel}
            disabled={loading}
            confirmBefore={confirmCancel}
            confirmMessage={cancelConfirmMessage}
            confirmOkLabel="Yes, cancel"
          />
        )}
        {onSave && (
          <StandardButton
            variant="action"
            iconName="Save"
            label={saveLabel}
            onClick={onSave}
            disabled={loading}
          />
        )}
      </div>

      {/* Right Section - Reserved for future */}
      <div style={{ display: 'flex', gap: '16px' }}>
        {/* Future: Share, bookmark, etc */}
      </div>
    </div>
  );
}

export default FooterButtonsDetail;
